import { useEffect, useState } from "react";

function debounce(func, wait, immediate) {
  var timeout;
  return function () {
    var that = this,
      args = arguments;
    var later = function () {
      timeout = null;
      if (!immediate) {
        func.apply(that, args);
      }
    };
    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) {
      func.apply(that, args);
    }
  };
}

export const useDebounce = (value, delay) => {
  const [debouncedValue, setDebouncedValue] = useState(value);
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);
    return () => {
      clearTimeout(handler);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);
  return debouncedValue;
};

export default debounce;
